import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";

export default function ReportsChart({ data }) {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const points = data || [];

  useEffect(() => {
    const labels = points.map((item) => item.label);

    const data = {
      labels,
      datasets: [
        {
          type: "bar",
          label: "Orders",
          backgroundColor: "#248afd",
          data: points.map((item) => Number(item.orders) || 0),
          yAxisID: "y",
        },
        {
          type: "line",
          label: "Sales (RS)",
          borderColor: "#db2585",
          backgroundColor: "#db2585",
          tension: 0.3,
          data: points.map((item) => Number(item.sales) || 0),
          yAxisID: "y1",
        },
      ],
    };

    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            fontColor: "black",
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: "black",
            font: {
              weight: 500,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          type: "linear",
          position: "left",
          ticks: {
            color: "black",
          },
          grid: {
            color: "lightgrey",
            drawBorder: false,
          },
        },
        y1: {
          type: "linear",
          position: "right",
          ticks: {
            color: "black",
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, [data]);

  return (
    <div className="card">
      <Chart type="bar" data={chartData} options={chartOptions} />
    </div>
  );
}
